import * as React from 'react';
import { UIText2 } from '@cian/ui-kit/typography';
import { IconMapCar16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './Roads.css';
import { IGeoRoadInfo } from '../../types/geo';

interface IRoadsProps {
  roads: IGeoRoadInfo[];
}

export function Roads({ roads }: IRoadsProps) {
  return (
    <>
      {roads
        .filter(road => road.distance)
        .map(roadItem => (
          <div className={styles['road']} key={`${roadItem.name}`}>
            <div className={styles['road-icon']}>
              <IconMapCar16 color={'icon-secondary-default'} />
            </div>
            <UIText2>{`${roadItem.name}, ${roadItem.distance} км от МКАД`}</UIText2>
          </div>
        ))}
    </>
  );
}
